import { useLocation } from 'react-router';
import type { Period } from '@/entities/types';

interface RouteInfo {
  periodParam: Period;
  targetDateParam?: string;
}

function isDateString(str?: string): boolean {
  if (!str) {
    return false;
  }
  // Check if string matches YYYY-MM-DD format
  return /^\d{4}-\d{2}-\d{2}$/.test(str);
}

export function useRouteInfo(): RouteInfo {
  const location = useLocation();

  // Extract path segments
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Determine period based on URL path
  let periodParam: Period;
  let dateCandidate: string | undefined;

  if (location.pathname.startsWith('/week')) {
    periodParam = 'week';
    // For /week/:targetDate paths, targetDate is the second segment
    dateCandidate = pathSegments[1];
  } else if (location.pathname.startsWith('/day')) {
    periodParam = 'day';
    // For /day/:targetDate paths, targetDate is the second segment
    dateCandidate = pathSegments[1];
  } else if (location.pathname.startsWith('/quarter')) {
    periodParam = 'quarter';
    // For /quarter/:targetDate paths, targetDate is the second segment
    dateCandidate = pathSegments[1];
  } else if (location.pathname.startsWith('/year')) {
    periodParam = 'year';
    // For /year/:targetDate paths, targetDate is the second segment
    dateCandidate = pathSegments[1];
  } else {
    // For /:targetDate paths (legacy), targetDate is the first segment
    periodParam = 'day';
    dateCandidate = pathSegments[0];
  }

  const targetDateParam = isDateString(dateCandidate)
    ? dateCandidate
    : undefined;

  return {
    periodParam,
    targetDateParam,
  };
}
